import React from 'react';

import { BottomNavigationAction, SvgIcon } from '@material-ui/core';

import { NotificationBadge } from '../NotificationBadge';
import styles from './AsaphBottomNavigationButton.module.scss';
import { AsaphNavigationButtonProps } from './AsaphTopNavigationButton';

export type AsaphBottomNavigationButtonProps = AsaphNavigationButtonProps & {
	defaultIcon: React.ElementType;
};

export const AsaphBottomNavigationButton = ({
	label,
	defaultIcon,
	hasNotification,
	isSelected,
	selectedIcon,
	style,
	...rest
}: AsaphBottomNavigationButtonProps) => {
	const iconComponent = selectedIcon ?? defaultIcon;
	const defaultIconToDisplay = (
		<SvgIcon
			component={iconComponent}
			classes={{ root: styles['nav-btn__icon'] }}
			style={style}
		/>
	);
	const selectedIconToDisplay = (
		<SvgIcon
			component={iconComponent}
			classes={{ root: styles['nav-btn__icon--selected'] }}
			style={style}
		/>
	);
	const iconToDisplay = isSelected
		? selectedIconToDisplay
		: defaultIconToDisplay;
	const finalIcon = hasNotification ? (
		<NotificationBadge
			type="notification"
			verticalPosition="top"
			horizontalPosition="right"
			overlap="circular"
		>
			{iconToDisplay}
		</NotificationBadge>
	) : (
		iconToDisplay
	);
	return (
		<BottomNavigationAction
			icon={finalIcon}
			label={label}
			showLabel
			classes={{
				root: styles['nav-btn__root'],
				label: styles['nav-btn__label'],
				selected: styles['nav-btn__label--selected'],
			}}
			TouchRippleProps={{
				classes: {
					root: styles['nav-btn__ripple'],
				},
			}}
			{...rest}
		/>
	);
};

export default AsaphBottomNavigationButton;
